import { Navbar, Nav, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./navbar.css";
import logo from "../assets/logo-lado.svg";

export default function Appnav() {
  return (
    <Navbar id="nav" expand="md">
      <Navbar.Brand href="/">
        <Image id="logo" rounded src={logo} alt="logo" />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
        <Navbar.Text>
          <Nav className="me-auto">
            <Navbar>
              <Link to="/" className="nav-text">
                Novidades
              </Link>
            </Navbar>
            <Navbar>
              <Link to="/galeria" className="nav-text">
                Galeria
              </Link>
            </Navbar>
            <Navbar>
              <Link to="/sobre" className="nav-text">
                Quem somos
              </Link>
            </Navbar>
            <Navbar>
              <Link to="/login" className="nav-text">
                <i className="material-icons">more_vert</i>{" "}
              </Link>
            </Navbar>
          </Nav>
        </Navbar.Text>
      </Navbar.Collapse>
    </Navbar>
  );
}
